import React from 'react';

export interface OfflinePlaceholderProps {
  box?: boolean;
  className?: string;
}

const Placeholder = ({ className }: { className?: string }) => (
  <img
    className={className || 'OfflinePlaceholder__image'}
    src={'/assets/images/offline-video.jpg'}
    alt="Offline"
  />
);

const PlaceholderBox = ({ className }: { className?: string }) => (
  <div className="OfflinePlaceholder--box">
    <div className="OfflinePlaceholder__container">
      <Placeholder className={className} />
    </div>
  </div>
);

const OfflinePlaceholder: React.FC<
  React.PropsWithChildren<OfflinePlaceholderProps>
> = ({ box, className }) => {
  return box ? (
    <PlaceholderBox className={className} />
  ) : (
    <Placeholder className={className} />
  );
};

export default OfflinePlaceholder;
